// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GalleryHeader_wrapper__qUMxL","container":"GalleryHeader_container__OyjNz","title":"GalleryHeader_title__8PIlg"};